
<div class="centered">
    <img src="../../../../assets/img/loading.gif" />
    <span class="blink">Redirecting ! Please wait...</span>
</div>